/* eslint-disable react/jsx-props-no-spreading */
import { Select } from "../../../Select/Select";
import { useCallback } from "react";
import FieldSuggestionChip from "../FieldSuggestionChip.component";
import { useTemplateController } from "../FieldContext";
import { getFormRulesFromMetadata } from "../utils";
import { InputFieldProps } from "./InputFieldBase";

const { Option } = Select;

export default function SelectInput({
  metadata,
  templateOverride,
  formLookupKey,
  templateKey,
  NotApplicableWrapper,
}: InputFieldProps): JSX.Element {
  const formRules = getFormRulesFromMetadata(metadata.value);
  const questionText = templateOverride?.questionText || metadata.questionText;
  const {
    field: { onChange, ...inputProps },
  } = useTemplateController({
    name: formLookupKey,
    ...(formRules && { rules: formRules }),
  });

  const handleChange = useCallback((value: string) => {
    if (!value) {
      return onChange(undefined);
    }
    return onChange(value);
  }, [onChange]);

  const handleApplySuggestion = useCallback(
    (suggested: unknown) => {
      const next = String(suggested ?? "");
      // Only apply if it's actually one of the known options (the worker
      // already runs `selectMatcher`, but extra defensiveness is cheap).
      if (metadata.options?.includes(next)) {
        onChange(next);
      } else {
        onChange(next || undefined);
      }
    },
    [onChange, metadata.options]
  );

  return (
    <>
      <div
        data-cy="template__textarea"
        data-test-id="template__textarea"
        className={"main-input__info"}
      >
        <div className="main-input__sublabel">{questionText}</div>
      </div>
      <NotApplicableWrapper {...{ templateKey, metadata }}>
        <span style={{ display: "inline-flex", alignItems: "center" }}>
          <Select
            style={{ marginRight: "20px", maxWidth: "60%" }}
            className="main-select"
            popupMatchSelectWidth={false}
            popupClassName="main-select__menu"
            onChange={handleChange}
            {...inputProps}
          >
            {metadata.options?.map(option => (
              <Option key={option} value={option} title={option}>
                {option}
              </Option>
            ))}
          </Select>
          <FieldSuggestionChip
            templateKey={templateKey}
            hideMultiStateView={metadata.value.hideMultiStateView}
            onApply={handleApplySuggestion}
            formatValue={v => String(v ?? "")}
          />
        </span>
      </NotApplicableWrapper>
    </>
  );
}
